import { render } from "./svgIcon.vue?vue&type=template&id=e269bf1c&scoped=true"
import script from "./svgIcon.vue?vue&type=script&lang=js"
export * from "./svgIcon.vue?vue&type=script&lang=js"

import "./svgIcon.vue?vue&type=style&index=0&id=e269bf1c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\danil\\PersonalData\\WebsiteDevelopment\\GitHub\\biorobot-factory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e269bf1c"]])

export default __exports__